import { x as h } from "../lit-element-6iugfgmM.js";
import { i as l } from "../query-D8_rwLua.js";
import "../query-assigned-elements-B8U94KLQ.js";
import { L as o } from "../like-anchor-1p1kOy4b.js";
var d = Object.defineProperty;
const b = (c) => {
  class a extends o(c) {
    get hasHref() {
      return !!this.href && this.href.length > 0;
    }
    connectedCallback() {
      super.connectedCallback(), this.hasHref && (this.classList.add("linkable"), this.setAttribute("role", "link"), this.addEventListener("click", this.handleClick), this.addEventListener("keypress", this.handleKeypress));
    }
    renderLinkable(e) {
      return h`${e} ${this.hasHref ? this.renderAnchor({ id: "anchor", className: "anchor", ariaHidden: !0, tabindex: -1 }) : ""}`;
    }
    handleClick() {
      this.anchorElement.click();
    }
    handleKeypress(e) {
      const { code: r } = e;
      switch (r) {
        case "Enter":
        case "Space":
          this.click();
      }
    }
  }
  return ((s, e, r) => {
    for (var i, t = void 0, n = s.length - 1; n >= 0; n--) (i = s[n]) && (t = i(e, r, t) || t);
    t && d(e, r, t);
  })([l(".anchor")], a.prototype, "anchorElement"), a;
};
export {
  b as LinkableCard
};
//# sourceMappingURL=LinkableCard.js.map
